export const reportsEn = {
  error: "Could not load the report.",
  retry: "Retry",
  empty: "No data for this period.",
  delta: "%{value} vs previous period",
  days: "%{value} day |||| %{value} days",
  conversion_label: "Conversion:",
  loading: "Loading…",
  legend: { current: "Selected period", previous: "Previous period" },
  filters: {
    label: "Report filters",
    period: "Period",
    from: "From",
    to: "To",
    rep: "Rep",
    all_reps: "All reps",
    all: "All",
    trade: "Trade",
    region: "Region",
    source: "Source",
    category: "Category",
    view: "View",
    compare: "Compare to previous period",
    range_invalid:
      "The start date must be before the end date. Showing this month.",
  },
  periods: {
    this_month: "This month",
    last_month: "Last month",
    quarter: "This quarter",
    custom: "Custom",
  },
  funnel: {
    title: "Sales funnel",
    prospecting: "Prospecting",
    deals: "Deals",
    cohort: "Deals created in period",
    snapshot: "Current deals by stage",
    win_rate: "Win rate",
    avg_won: "Average deal won",
    cycle: "Median sales cycle",
    steps: {
      called: "Leads called",
      reached: "Reached",
      interested: "Interested",
      demos_booked: "Demos booked",
      demos_held: "Demos held",
    },
    columns: {
      stage: "Stage",
      count: "Current deals",
      amount: "Amount",
      reached: "Reached stage",
      conv_next: "Conversion to next stage",
      median_days: "Median days in stage",
    },
  },
  unknown: "Not set",
  table_view: "Show as table",
  index: {
    title: "Reports",
    funnel: "Prospecting and deals, conversions and sales cycle",
    activity: "Calls, contacts, demos and talk time per day and rep",
    call_outcomes:
      "Outcomes by trade, region and hour — find the best times to call",
    emails_title: "Email",
    emails: "Campaign and sequence performance",
    sources: "Deals and sales by source",
    loss: "Lost deals by reason and rep",
    quality: "Invalid phones, no email, unassigned, duplicates, stale",
  },
  activity: {
    title: "Activity by rep",
    columns: {
      day: "Day",
      rep: "Rep",
      dials: "Calls",
      contacts: "Contacts",
      voicemails: "Voicemails",
      demos: "Demos",
      talk_time: "Talk time",
      first_call: "First call",
      last_call: "Last call",
      sessions: "Sessions",
    },
  },
  call_outcomes: {
    title: "Call outcomes",
    outcomes: "Outcomes",
    heatmap: "Contact rate by day and hour",
    cell: "%{day} %{hour}:00: %{smart_count} call, %{rate} contact |||| %{day} %{hour}:00: %{smart_count} calls, %{rate} contact",
    cell_empty: "%{day} %{hour}:00: no calls",
    legend_low: "0%",
    legend_high: "%{rate}",
    legend_none: "No calls",
    day: "Day",
    hour: "Hour",
    dials: "Calls",
    rate: "Contact rate",
  },
  outcomes: {
    no_answer: "No answer",
    voicemail: "Voicemail",
    talked_callback: "Talked – call back",
    demo_booked: "Demo booked",
    brochure_sent: "Brochure sent",
    not_interested: "Not interested",
    wrong_number: "Wrong number",
    do_not_call: "Do not call",
    unlogged: "Not logged",
  },
  weekdays: {
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
    7: "Sunday",
  },
  loss: {
    title: "Loss reasons",
    by_reason: "Lost deals by reason",
    by_rep: "Reasons by rep",
    reason: "Reason",
    count: "Deals",
    amount: "Amount",
  },
  sources: {
    title: "Deal sources",
    deals: "Deals created",
    won: "Won",
    won_amount: "Won amount",
  },
  quality: {
    title: "Data quality",
    description: "Across all leads.",
    invalid_phone: "No valid phone",
    no_email: "No email",
    unassigned: "Unassigned",
    duplicate_phone: "Duplicates (same phone)",
    duplicate_name_city: "Duplicates (name + city)",
    stale_90d: "Untouched for 90 days",
    share: "%{pct} of leads",
  },
};
